/* ==================================================
  Scrolled Class
================================================== */

let scrollpos = window.scrollY;

window.addEventListener('scroll', function() {
  scrollpos = window.scrollY;

  if (scrollpos >= 40) {
    document.body.classList.add("scrolled");
  } else {
    document.body.classList.remove("scrolled");
  }

})


/* ==================================================
  Mobile Menu
================================================== */

const navOverlayToggle = document.getElementById('nav-overlay-toggle');
const navOverlayClose = document.getElementById('nav-overlay-close');
const navOverlayMenu = document.getElementById('nav-overlay-menu');

// Open Overlay Menu
navOverlayToggle.addEventListener('click', () => {
  navOverlayToggle.setAttribute('aria-expanded', true)
  navOverlayMenu.setAttribute('aria-hidden', false)
})
// Close Overlay Menu
navOverlayClose.addEventListener('click', () => {
  navOverlayToggle.setAttribute('aria-expanded', false)
  navOverlayMenu.setAttribute('aria-hidden', true)
})